export const useIsLocalHost = () => {
  return window.location.hostname === 'localhost';
};
